export const publicKey = ""